import React, { useState, useReducer, useRef, useEffect } from 'react'
import {
  AppBar,
  Tabs,
  TextField,
  Typography,
  Tab,
  Grid,
  IconButton,
  Button
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import axios from 'axios'
import { ReactComponent as DescriptionIcon } from 'static/icons/description.svg'
import { ReactComponent as DocumentsIcon } from 'static/icons/documents_files.svg'
import { ReactComponent as ActionPlanIcon } from 'static/icons/action_plan.svg'
import { ReactComponent as ApplicableLawsIcon } from 'static/icons/applicable.svg'
import stringify from 'json-stable-stringify'
import { useDispatch, useSelector } from 'react-redux'
import { formReducer, getFieldError } from 'helpers/forms'
import {
  getByIdFromArray,
  replaceByTargetFromArray,
  removeByIdFromArray,
  getIdArray,
  getUniqueArrayById
} from 'helpers/dataHelpers'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { setActiveAdviceId, updateAdviceByTarget } from 'utils/advices/actions'
import history from 'browserHistory'
import Modal from 'components/Modal'
import RichTextField from 'components/RichTextField'
import AddActionModal from 'components/AddActionModal'
import AddApplicableLaw from 'components/AddApplicableLaw'
import DomainsInput from 'components/DomainsInput'
import GroupsInput from 'components/GroupsInput'
import RoomsInput from 'components/RoomsInput'
import LawsInput from 'components/LawsInput'
import DocumentListItem from 'components/DocumentListItem'
import ActionListItem from 'components/ActionListItem'
import LawListItem from 'components/LawListItem'
import KeywordsSet from 'components/KeywordsSet'
import AreYouSureModal from 'components/AreYouSureModal'
import Loader from 'components/Loader'
import useStyles from './styles'
import Config from 'config'

const initFormsState = {
  errors: {}
}


const AddAdviceModal = (props) => {
  const {
    isPublished,
    adviceId,
    setShowDialog,
    showDialog,
    adviceData,
    submitCallback
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [formErrors, dispatchFormErrors] = useReducer(formReducer, initFormsState)
  const [isLoading, setIsLoading] = useState(false)
  const [localIsPublished, setLocalIsPublished] = useState(isPublished)
  const [isFileLoading, setIsFileLoading] = useState(false)
  const [initialAdvice, setInitialAdvice] = useState(null)
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false)
  const [showActionModal, setShowActionModal] = useState(false)
  const [showApplicableLawModal, setShowApplicableLawModal] = useState(false)
  const [tabValue, setTabValue] = useState('summary')
  const [adviceHtml, setAdviceHtml] = useState('')
  const [activeAdvice, setActiveAdvice] = useState(null)
  const [roomsOptions, setRoomsOptions] = useState([])
  const [valueDomains, setValueDomains] = useState([])
  const [valueRooms, setValueRooms] = useState([])
  const [valueGroups, setValueGroups] = useState([])
  const [valueDocuments, setValueDocuments] = useState([])
  const [valueActions, setValueActions] = useState([])
  const [valueLaws, setValueLaws] = useState([])
  const [selectedDocuments, setSelectedDocuments] = useState([])
  const [selectedActions, setSelectedActions] = useState([])
  const [selectedLaws, setSelectedLaws] = useState([])
  const [rulesSets, setRulesSets] = useState([[{}]])
  const [controlledGroups, setControlledGroups] = useState([])

  const buttonAction = useRef()

  const titleInputRef = useRef(null)
  const summaryInputRef = useRef(null)
  const summaryRef = useRef(null)
  const adviceRef = useRef(null)
  const docuentsRef = useRef(null)
  const actionPlanRef = useRef(null)
  const lawsRef = useRef(null)
  const keywordsRef = useRef(null)


  useEffect(() => {
    dispatchFormErrors({ type: 'reset' })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const advices = useSelector(state => state.advices.advices)
  const activeAdviceId = useSelector(state => state.advices.adviceId)

  const getAdviceData = () => {
    let adviceDict = null
    if (adviceId) {
      adviceDict = getByIdFromArray(advices, adviceId)
    }
    if (!adviceDict && adviceData && adviceData.title) {
      adviceDict = adviceData
      if (activeAdviceId !== adviceData.id) {
        dispatch(setActiveAdviceId(adviceData.id))
      }
    }
    setActiveAdvice(adviceDict)
  }
  
  const formRef = useRef()
  const fileInputRef = useRef()

  const localClasses = useStyles()

  useEffect(() => {
    getAdviceData()
    return () => dispatch(setActiveAdviceId(null))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (activeAdvice) {
      setSelectedDocuments(activeAdvice.documents)
      setSelectedActions(activeAdvice.actions)
      setSelectedLaws(activeAdvice.laws)
      setAdviceHtml(activeAdvice.text)
      setLocalIsPublished(activeAdvice.is_active)
      setRulesSets(activeAdvice.raw_keywords ? activeAdvice.raw_keywords : [[{}]])
      setInitialAdvice(stringify({
        // actions: activeAdvice.actions ? getIdArray(activeAdvice.actions).sort() : [],
        groups: activeAdvice.groups ? getIdArray(activeAdvice.groups).sort() : [],
        documents: activeAdvice.documents ? getIdArray(activeAdvice.documents).sort() : [],
        laws: activeAdvice.laws ? getIdArray(activeAdvice.laws).sort() : [],
        rooms: activeAdvice.rooms ? getIdArray(activeAdvice.rooms).sort() : [],
        summary: activeAdvice.summary,
        text: activeAdvice.text,
        title: activeAdvice.title,
        raw_keywords: activeAdvice.raw_keywords ? activeAdvice.raw_keywords : []
      }))
    }
  }, [activeAdvice]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setValueDocuments(getIdArray(selectedDocuments))
  }, [selectedDocuments]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setValueActions(getIdArray(selectedActions))
  }, [selectedActions]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setValueLaws(getIdArray(selectedLaws))
  }, [selectedLaws]) // eslint-disable-line react-hooks/exhaustive-deps

  const getDefaultDomainsValue = (rooms) => {
    let domains = []
    for (let i = 0, length = rooms.length; i < length; i += 1) {
      domains = [...rooms[i].domains, ...domains]
    }
    const uniqueDomains = getUniqueArrayById(domains)
    return uniqueDomains
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
    const getTargetElement = () => {
      switch (newValue) {
        case 'advice':
          return adviceRef
        case 'docs':
          return docuentsRef
        case 'actions':
          return actionPlanRef
        case 'laws':
          return lawsRef
        case 'keywords':
          return keywordsRef
        default:
          return summaryRef
      }
    }
    const targetRef = getTargetElement()
    targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0]
    const filename = file.name
    setIsFileLoading(true)
    const url = `${apiUrl}documents/`
    const formData = new FormData()
    formData.append('name', filename)
    formData.append('file', file)
    axios.post(url, formData).then((body) => {
      const { data } = body
      handleDocumentListChange('create', data)
      setIsFileLoading(false)
      dispatch(setSnackbar('File uploaded'))
    }).catch(err => {
      if (err.response) {
        dispatch(checkErrorStatus(err.response.status))
        setIsLoading(false)
        if (err.response.status === 400) {
          dispatchFormErrors({
            type: 'error',
            payload: err.response.data
          })
        } else {
          dispatchFormErrors({
            type: 'error',
            payload: {
              nonField: [err.response.data.detail]
            }
          })
        }
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  const prepareRulesSets = () => {
    const preparedRulesSets = [...rulesSets]
    for (let i = preparedRulesSets.length - 1; i >= 0; i -= 1) {
      for (let j = preparedRulesSets[i].length - 1; j >= 0; j -= 1) {
        if (JSON.stringify(preparedRulesSets[i][j]) === '{}') {
          preparedRulesSets[i].splice(j, 1)
        }
      }
      if (JSON.stringify(preparedRulesSets[i]) === '[]') {
        preparedRulesSets.splice(i, 1)
      }
    }
    return preparedRulesSets
  }

  const addAdviceSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()
    dispatchFormErrors({ type: 'reset' })
    setIsLoading(true)
    const url = `${apiUrl}advices/`
    const title = event.target.elements.title.value
    const summary = event.target.elements.summary.value
    const requestData = {
      title: title,
      summary: summary,
      text: adviceHtml,
      domains: valueDomains,
      rooms: valueRooms,
      groups: valueGroups,
      documents: valueDocuments,
      actions: valueActions,
      laws: valueLaws,
      raw_keywords: prepareRulesSets()
    }
    if (localIsPublished) {
      requestData.parent = adviceId
    }
    axios.post(url, requestData).then((body) => {
      const { data } = body
      dispatch(setActiveAdviceId(data.id))
      dispatch(updateAdviceByTarget(data))
      setActiveAdvice(data)
      dispatch(setSnackbar('Advice draft created'))
      setIsLoading(false)
      if (submitCallback) {
        submitCallback()
      }
      if (buttonAction.current === 'saveAndClose') {
        history.push(`/${data.id}`)
        setShowDialog(false)
      }
    }).catch(err => {
      if (err.response) {
        dispatch(checkErrorStatus(err.response.status))
        setIsLoading(false)
        if (err.response.status === 400) {
          dispatchFormErrors({
            type: 'error',
            payload: err.response.data
          })
        } else {
          dispatchFormErrors({
            type: 'error',
            payload: {
              nonField: [err.response.data.detail]
            }
          })
        }
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  const editAdviceSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()
    dispatchFormErrors({ type: 'reset' })
    setIsLoading(true)
    const url = `${apiUrl}advices/${activeAdviceId}/`
    const title = event.target.elements.title.value
    const summary = event.target.elements.summary.value
    const requestData = {
      title: title,
      summary: summary,
      text: adviceHtml,
      domains: valueDomains,
      rooms: valueRooms,
      groups: valueGroups,
      documents: valueDocuments,
      actions: valueActions,
      laws: valueLaws,
      raw_keywords: prepareRulesSets()
    }
    // if (localIsPublished) {
    //   requestData.parent = adviceId
    // }
    axios.put(url, requestData).then((body) => {
      const { data } = body
      dispatch(setActiveAdviceId(data.id))
      dispatch(updateAdviceByTarget(data))
      setActiveAdvice(data)
      dispatch(setSnackbar('Advice updated'))
      setIsLoading(false)
      if (submitCallback) {
        submitCallback()
      }
      if (buttonAction.current === 'saveAndClose') {
        history.push(`/${data.id}`)
        setShowDialog(false)
      }
    }).catch(err => {
      if (err.response) {
        dispatch(checkErrorStatus(err.response.status))
        setIsLoading(false)
        if (err.response.status === 400) {
          dispatchFormErrors({
            type: 'error',
            payload: err.response.data
          })
        } else if (err.response.status === 417) {
          dispatch(setSnackbar('Can not update Published Advice. Please refresh the page', 'error'))
        } else {
          dispatchFormErrors({
            type: 'error',
            payload: {
              nonField: [err.response.data.detail]
            }
          })
        }
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  const handleDocumentListChange = (actionType, data) => {
    if (actionType === 'create') {
      setSelectedDocuments([...selectedDocuments, ...[data]])
    } else if (actionType === 'remove') {
      setSelectedDocuments(removeByIdFromArray(selectedDocuments, data.id))
    }
  }

  const handleActionListChange = (actionType, data) => {
    if (actionType === 'create') {
      setSelectedActions([...selectedActions, ...[data]])
    } else if (actionType === 'edit') {
      setSelectedActions(replaceByTargetFromArray(selectedActions, data))
    } else if (actionType === 'remove') {
      setSelectedActions(removeByIdFromArray(selectedActions, data.id))
    }
  }

  const handleLawListChange = (actionType, data) => {
    if (actionType === 'create') {
      const uniqueLaws = getUniqueArrayById([...selectedLaws, ...[data]])
      setSelectedLaws(uniqueLaws)
    } else if (actionType === 'edit') {
      setSelectedLaws(replaceByTargetFromArray(selectedLaws, data))
    } else if (actionType === 'remove') {
      setSelectedLaws(removeByIdFromArray(selectedLaws, data.id))
    }
  }

  const handleAddSet = () => {
    setRulesSets([...rulesSets, ...[[{}]]])
  }

  const handleRemoveSet = (setIndex) => {
    const newRulesSets = [...rulesSets]
    newRulesSets.splice(setIndex, 1)
    setRulesSets(newRulesSets)
  }

  const handleAddRule = (setIndex) => {
    const newRulesSets = [...rulesSets]
    newRulesSets[setIndex].push([{}])
    setRulesSets(newRulesSets)
  }

  const handleRemoveRule = (setIndex, ruleIndex) => {
    const newRulesSets = [...rulesSets]
    newRulesSets[setIndex].splice(ruleIndex, 1)
    if (newRulesSets[setIndex].length === 0) {
      newRulesSets.splice(setIndex, 1)
    }
    setRulesSets(newRulesSets)
  }

  const handleUpdateRule = (setIndex, ruleIndex, ruleData) => {
    rulesSets[setIndex][ruleIndex] = ruleData
  }

  const renderDocuments = () => {
    return selectedDocuments.map((doc, index) => (
      <DocumentListItem
        key={doc.id}
        isAdvice
        handleListItemChange={handleDocumentListChange}
        {...doc}
      />
    ))
  }

  const renderActions = () => {
    return selectedActions.map((action, index) => (
      <ActionListItem
        key={action.id}
        isAdvice
        handleListItemChange={handleActionListChange}
        {...action}
      />
    ))
  }

  const renderLaws = () => {
    return selectedLaws.map((law, index) => (
      <LawListItem
        key={law.id}
        isAdvice
        handleListItemChange={handleLawListChange}
        {...law}
      />
    ))
  }

  const renderRulesSets = () => {
    return rulesSets.map((set, index) => (
      <KeywordsSet
        key={`set-${index}`}
        rules={set}
        setIndex={index}
        addRule={handleAddRule}
        removeRule={handleRemoveRule}
        removeSet={handleRemoveSet}
        updateRule={handleUpdateRule}
      />
    ))
  }

  const checkIfDirty = () => {
    if (!initialAdvice) {
      return false
    }
    const currentData = stringify({
      // actions: valueActions.sort(),
      groups: valueGroups.sort(),
      documents: valueDocuments.sort(),
      laws: valueLaws.sort(),
      rooms: valueRooms.sort(),
      summary: summaryInputRef.current.value,
      text: adviceHtml,
      title: titleInputRef.current.value,
      raw_keywords: rulesSets
    })
    return initialAdvice !== currentData
  }

  return (
    <Modal
      open={showDialog}
      onClose={() => {
        if (checkIfDirty()) {
          setShowAreYouSureModal(true)
        } else {
          setShowDialog(false)
        }
      }}
      header={activeAdviceId ? 'Edit Advice' : 'Create Advice'}
      isLoading={isLoading}
      action={
        () => {
          buttonAction.current = 'saveAndClose'
          formRef.current.dispatchEvent(new Event('submit'))
        }
      }
      secondaryAction={
        () => {
          buttonAction.current = 'save'
          formRef.current.dispatchEvent(new Event('submit'))
        }
      }
      actionText='Save and close'
      secondaryActionText='Save'
      maxWidth='xl'
      additionalContentClasses={localClasses.modalContent}
      disableEnforceFocus={true}
      disableBackdropClick={true}
      primaryActionId='saveAndClose'
      secondaryActionId='save'
    >
      <AppBar
        position='sticky'
        color='default'
        className={localClasses.appBar}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor='primary'
          textColor='primary'
          aria-label='nav tabs'
        >
          <Tab label='Summary' value='summary' />
          <Tab label='Advice' value='advice' />
          <Tab label='Documents' value='docs' />
          <Tab label='Action plan' value='actions' />
          <Tab label='Applicable Laws' value='laws' />
          <Tab label='Keywords' value='keywords' />
        </Tabs>
      </AppBar>
      <form onSubmit={localIsPublished || !activeAdviceId ? addAdviceSubmit : editAdviceSubmit } ref={formRef}>
        { getFieldError(formErrors, 'nonField') ?
        <p className='error-message'>{getFieldError(formErrors, 'nonField')}</p> : null }
        <input
          type='file'
          id='file'
          ref={fileInputRef}
          style={{display: 'none'}}
          onChange={handleFileChange}
        />
        <Typography variant='h6' className={localClasses.generalInfoHeader}>
          General Infomation
        </Typography>
        <TextField
          required
          inputRef={titleInputRef}
          error={!!getFieldError(formErrors, 'title')}
          helperText={getFieldError(formErrors, 'title')}
          label='Advice title'
          type='text'
          name='title'
          fullWidth
          variant='outlined'
          defaultValue={activeAdvice ? activeAdvice.title : null}
        />

        <Grid container>
          <Grid item xs={6} className={localClasses.domainsGrid}>
            <DomainsInput
              error={!!getFieldError(formErrors, 'domains')}
              helperText={getFieldError(formErrors, 'domains')}
              setValue={setValueDomains}
              defaultValue={activeAdvice ? getDefaultDomainsValue(activeAdvice.rooms) : []}
              setRoomsOptions={setRoomsOptions}
              setGroupsValue={setControlledGroups}
            />
          </Grid>
          <Grid item xs={6} className={localClasses.roomsGrid}>
            <RoomsInput
              error={!!getFieldError(formErrors, 'rooms')}
              helperText={getFieldError(formErrors, 'rooms')}
              setValue={setValueRooms}
              defaultValue={activeAdvice ? activeAdvice.rooms : []}
              rooms={roomsOptions}
              required
            />
          </Grid>
        </Grid>

        <GroupsInput
          error={!!getFieldError(formErrors, 'groups')}
          helperText={getFieldError(formErrors, 'groups')}
          setValue={setValueGroups}
          defaultValue={activeAdvice ? activeAdvice.groups : []}
          controlledGroups={controlledGroups}
        />

        <TextField
          ref={summaryRef}
          inputRef={summaryInputRef}
          required
          error={!!getFieldError(formErrors, 'summary')}
          helperText={getFieldError(formErrors, 'summary')}
          label='Summary'
          type='text'
          name='summary'
          fullWidth
          variant='outlined'
          multiline
          rows={4}
          defaultValue={activeAdvice ? activeAdvice.summary : null}
        />

        <Typography ref={adviceRef} variant='h6' className={localClasses.adviceSubHeader}>
          <div className={localClasses.headerText}><DescriptionIcon /> Advice</div>
        </Typography>
        {
          !!getFieldError(formErrors, 'text') && <p className={localClasses.errorMessage}>{getFieldError(formErrors, 'text')}</p>
        }
        <RichTextField
          defaultValue={activeAdvice ? activeAdvice.text : null}
          setValue={setAdviceHtml}
        />
        <Typography ref={docuentsRef} variant='h6' className={localClasses.adviceSubHeader}>
          <div className={localClasses.headerText}><DocumentsIcon /> Document(s)</div>
          <IconButton
            aria-label='add document'
            color='primary'
            onClick={()=> fileInputRef.current.click()}
          >
            <AddIcon />
          </IconButton>
        </Typography>
        <div className={localClasses.documentsHeaders}>
          <Typography
            variant='h6'
            className={localClasses.documentName}
          >
            Title
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.documentLink}
          >
            Link
          </Typography>

        </div>
        <div
          className={localClasses.documentsList}
        >
          {
            isFileLoading && <Loader />
          }
          {
            selectedDocuments.length === 0 ?
            <p>No documents selected</p> :
            renderDocuments()
          }
        </div>
        <Typography ref={actionPlanRef} variant='h6' className={localClasses.adviceSubHeader}>
          <div className={localClasses.headerText}><ActionPlanIcon /> Action(s)</div>
          <IconButton
            aria-label='add action'
            color='primary'
            onClick={() => setShowActionModal(true)}
          >
            <AddIcon />
          </IconButton>
          <AddActionModal
            setShowDialog={setShowActionModal}
            showDialog={showActionModal}
            getValue={handleActionListChange}
          />
        </Typography>
        <div className={localClasses.documentsHeaders}>
          <Typography
            variant='h6'
            className={localClasses.actionDescription}
          >
            Description
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.actionWho}
          >
            Who
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.actionDeadline}
          >
            Deadline
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.actionRepeat}
          >
            Repeat
          </Typography>

        </div>
        <div>
          {
            selectedActions.length === 0 ?
            <p>No actions selected</p> :
            renderActions()
          }
        </div>
        <Typography ref={lawsRef} variant='h6' className={localClasses.adviceSubHeader}>
          <div className={`${localClasses.headerText} ${localClasses.lawsHeader}`}><ApplicableLawsIcon /> Applicable Laws</div>
          <LawsInput
            error={!!getFieldError(formErrors, 'laws')}
            helperText={getFieldError(formErrors, 'laws')}
            setValue={setValueLaws}
            // defaultValue={activeAdvice ? activeAdvice.laws : []}
            additionalClasses={localClasses.lawsInput}
            notRequired
            single
            getValue={handleLawListChange}
            valueLaws={valueLaws}
          />
          <IconButton
            aria-label='add law'
            color='primary'
            onClick={() => setShowApplicableLawModal(true)}
          >
            <AddIcon />
          </IconButton>
          <AddApplicableLaw
            setShowDialog={setShowApplicableLawModal}
            showDialog={showApplicableLawModal}
            getValue={handleLawListChange}
          />
        </Typography>
        <div className={localClasses.documentsHeaders}>
          <Typography
            variant='h6'
            className={localClasses.lawShortName}
          >
            Short name
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.lawCountry}
          >
            Country
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.lawArticles}
          >
            Articles
          </Typography>

          <Typography
            variant='h6'
            className={localClasses.lawLink}
          >
            Link
          </Typography>

        </div>
        <div>
          {
            selectedLaws.length === 0 ?
            <p>No laws selected</p> :
            renderLaws()
          }
        </div>
        <Typography ref={keywordsRef} variant='h6' className={localClasses.adviceSubHeader}>
          <div className={localClasses.headerText}><ActionPlanIcon /> Keywords</div>
        </Typography>
        <div>
          {
            renderRulesSets()
          }
        </div>
        <div className={localClasses.addNewSetContainer}>
          <Button
            variant='outlined'
            color='primary'
            endIcon={<AddIcon/>}
            onClick={handleAddSet}
          >
            Create new set
          </Button>
        </div>
      </form>
      {
        showAreYouSureModal ?
          <AreYouSureModal
            setShowDialog={setShowAreYouSureModal}
            showDialog={showAreYouSureModal}
            actionText='Close'
            actionDescription='You have unsaved changes. Are you sure you want to close?'
            action={() => setShowDialog(false)}
          /> : null
      }
    </Modal>
  )
}

export default AddAdviceModal
